import { render } from "./DossierCohorteItem.vue?vue&type=template&id=595a11bc&scoped=true"
import script from "./DossierCohorteItem.vue?vue&type=script&lang=js"
export * from "./DossierCohorteItem.vue?vue&type=script&lang=js"

import "./DossierCohorteItem.vue?vue&type=style&index=0&id=595a11bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595a11bc"]])

export default __exports__